<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-button type="primary" size="mini" v-if="!lo" class="float-right borcmodalbuton" @click="this.Borclandir">Borçlandırmayı Onayla</el-button>
    <div class="clearfix"></div>
    <hr>
    <table class="table table-xs table-hover">
      <thead>
      <tr>
        <th width="200">Borçlu Adı Soyadı</th>
        <th width="20">M2</th>
        <th width="200">Mesken Bilgi</th>
        <th width="50"></th>

      </tr>
      </thead>
      <tbody v-for="(Onay,index) in data">
      <tr :class="Onay.TableClass">
        <td>{{Onay.Mesken.Oturan.AdSoyad}}</td>
        <td>{{Onay.Mesken.DaireBilgi}}</td>
        <td>{{Onay.Mesken.m2}}</td>
        <td class="text-right"><a v-if="!Onay.Muaf" class="el-button el-button--mini el-button--info el-button--default"
                                  data-toggle="collapse" :href="'#BorcTable'+Onay.Mesken.id" role="button">
          Taksit Planı
        </a></td>
      </tr>
      <tr class="collapse" :class="index==0?'show':''" v-if="!Onay.Muaf" :id="'BorcTable'+Onay.Mesken.id">
        <td colspan="4" style="padding: 0 !important;">
          <table class="table table-xs table-hover BorcTable" style="margin: 0 !important;">
            <thead>
            <tr :class="Onay.TableClass">
              <th width="100">Borçlanma Tarihi</th>
              <th width="100">Son Ödeme Tarihi</th>
              <th width="150">Kategori</th>
              <th width="80">Tutar</th>
              <th width="40">Zam Oran</th>
              <th width="300">Açıklama</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="Borclar in Onay.Mesken.Borclar">
              <td>{{Borclar.tTarihiText}}</td>
              <td>{{Borclar.sTarihiText}}</td>
              <td>{{Borclar.KategoriText}}</td>
              <td><input v-model="Borclar.Tutar" class="form-control">
                <ol v-if="Borclar.IndirimDetay.Detay" class="IndirimList">
                  <p>{{Borclar.IndirimDetay.Oran}}% İndirim Uygulandı</p>
                  <li v-for="Detay in Borclar.IndirimDetay.Detay"><span>{{Detay.Tanim}}</span> {{Detay.Oran}} %</li>
                </ol>
              </td>
              <td><input v-model="Borclar.zOran" class="form-control"></td>
              <td><input v-model="Borclar.Aciklama" class="form-control"></td>

            </tr>
            </tbody>
          </table>
        </td>
      </tr>

      </tbody>
    </table>


  </div>
</template>

<script>
  import Yukleniyor from "../../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: {
      data: [],
    },
    data() {
      return {
        lo:false
      }
    },
    methods: {
      Borclandir() {
        this.lo = true
        this.$store.dispatch("Post", {...this.data, path: 'muhasebe/tahakkuk/tahakkuk/onayla'})
          .then(response => {
            if (response.Durum == "OK") {
              this.$emit("Onay", true);
              this.$message.success(response.Mesaj);
              this.lo = false
            } else {
              this.$message.error(response.Mesaj);
              this.lo = false
            }
          })

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Muhasebe/tahakkuk/Taksitli.vue